



























































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { Actions, Mutations } from '@/ts/store/Constants';
import { TableView } from '@/ts/interfaces/TableConfigTypes';
import AddViewModal from '@/components/Tables/AddViewModal.vue';
import DeleteViewModal from '@/components/Tables/DeleteViewModal.vue';

@Component({
    components: {
        AddViewModal,
        DeleteViewModal,
    },
})
export default class FlexibleTable extends Vue {
    @Prop() public columns: any;
    @Prop() public data: any;
    @Prop() public selectedRows: any;
    @Prop() public selectable: boolean;
    @Prop() public selectionType: string;
    @Prop() public csvDownload: boolean;
    @Prop() public search: boolean;
    @Prop() public fileName: string;
    @Prop() public withCharts: boolean;
    @Prop() public withActionButtons: boolean;
    @Prop() public selectableRows: boolean;
    @Prop({default: false}) public showLoading: boolean;
    @Prop({required: true}) public tableKey: string;
    @Prop({required: true}) public enableViews: boolean;
    @Prop({required: true}) public defaultTableConfig: TableView;
    @Prop({ default: false }) public withExpandRows: boolean;

    public selected: any = [];
    public addViewModal = false;
    public deleteViewModal = false;
    public viewToDelete = null;

    constructor() {
        super();
    }

    get paginationConfig(): any {
        return {
            rowsPerPage: 20,
        };
    }

    get viewOptionList(): TableView[] {
        const optionList = (this.tableConfig && this.tableConfig.viewOptionList) ? this.tableConfig.viewOptionList : [];
        if (this.defaultView) {
            return [...optionList, this.defaultView];
        }
        return optionList;
    }

    get tableConfig() {
        return this.$store.getters['TableConfigs/getTableConfig'](this.tableKey);
    }

    get selectedView() {
        if (this.tableConfig && this.tableConfig.selectedView) {
            return this.tableConfig.selectedView;
        }
        return null;
    }

    get defaultView() {
        if (this.tableConfig && this.tableConfig.defaultView) {
            return this.tableConfig.defaultView;
        }
        return null;
    }

    get requireLoading(): boolean {
        return this.showLoading && !this.$store.getters['Loading/getLoadingStatus'];
    }

    public rowWasClicked(rowProp: any) {
        this.$emit('rowWasClicked', rowProp.row.id);
    }

    public getSelected(selected: any) {
        this.selected = selected;
        this.$emit('itemsSelected', this.selected);
    }

    public removeSelections() {
        this.selected = [];
    }

    public created() {
        this.$store.dispatch(Actions.INITIALIZE_TABLE_CONFIG, {key: this.tableKey, defaultTableConfig: this.defaultTableConfig, enableViews: this.enableViews});
        this.selected = this.selectedRows;
    }

    public onConfigChange(config) {
        this.$store.commit(Mutations.SET_SELECTED_VIEW_CONFIG, {
            key: this.tableKey,
            config,
        });
    }

    public onViewSelected(view) {
        this.$store.commit(Mutations.SET_SELECTED_VIEW, {
            key: this.tableKey,
            view,
        });
    }

    public onViewOptionDelete(view) {
        this.viewToDelete = view;
        this.onShowDeleteModal();
    }

    public onToggleViewDefaultValue(view: TableView) {
        this.$store.dispatch(Actions.UPDATE_TABLE_VIEW_DEFAULT_VALUE, {
            key: this.tableKey,
            view,
            value: !view.default,
        });
    }

    public onSubmitNewView(name: string) {
        this.$store.dispatch(Actions.CREATE_NEW_VIEW, {
            key: this.tableKey,
            name,
        }).then(() => {
            this.addViewModal = false;
        }).catch(() => {
            this.addViewModal = false;
        });
    }

    public onSaveSelectedView() {
        this.$store.dispatch(Actions.SAVE_SELECTED_TABLE_VIEW, {
            key: this.tableKey,
        });
    }

    public onShowCreateViewModal() {
        this.addViewModal = true;
    }

    public onShowDeleteModal() {
        this.deleteViewModal = true;
    }

    public onConfirmDeleteView() {
        this.$store.dispatch(Actions.DELETE_TABLE_VIEW, {
            key: this.tableKey,
            view: this.viewToDelete,
        }).then(() => {
            this.viewToDelete = null;
            this.deleteViewModal = false;
        });
    }
}
